var render = function () {
  var _vm$item, _vm$item2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Admin',
        to: '/user-admin'
      }, {
        label: (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.email
      }],
      "title": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.email
    }
  }), _c('div', {
    staticClass: "w-full p-6 my-3 bg-white rounded-lg shadow-sm"
  }, [_vm._m(0), _c('div', {
    staticClass: "grid grid-cols-2 gap-x-12 gap-y-6"
  }, [_c('div', {
    staticClass: "space-y-6"
  }, [_c('div', [_c('DescriptionTerm', {
    staticClass: "mb-1 text-sm font-medium text-gray-600"
  }, [_vm._v("Email")]), _c('DescriptionDetail', {
    staticClass: "text-gray-900 lower-case",
    attrs: {
      "isLoading": _vm.isLoadingAdmin
    }
  }, [_vm._v(_vm._s(_vm.email || '-'))])], 1), _c('div', [_c('DescriptionTerm', {
    staticClass: "mb-1 text-sm font-medium text-gray-600"
  }, [_vm._v("Role")]), _c('DescriptionDetail', {
    staticClass: "text-gray-900",
    attrs: {
      "isLoading": _vm.isLoadingAdmin
    }
  }, [_vm._v(_vm._s(_vm.role || '-'))])], 1), _c('div', [_c('DescriptionTerm', {
    staticClass: "mb-1 text-sm font-medium text-gray-600"
  }, [_vm._v("Publisher Group")]), _c('DescriptionDetail', {
    staticClass: "text-gray-900 capitalize",
    attrs: {
      "isLoading": _vm.isLoadingAdmin
    }
  }, [_vm._v(_vm._s(_vm.group || '-'))])], 1)]), _c('div', [_c('div', [_c('DescriptionTerm', {
    staticClass: "mb-1 text-sm font-medium text-gray-600"
  }, [_vm._v("Status")]), _c('DescriptionDetail', {
    attrs: {
      "isLoading": _vm.isLoadingAdmin
    }
  }, [_c('Label', {
    staticClass: "text-sm",
    attrs: {
      "variant": _vm.isActive ? 'green' : 'gray'
    }
  }, [_vm._v(" " + _vm._s(_vm.isActive ? 'Active' : 'Inactive') + " ")])], 1)], 1)])])]), _c('PasswordInputModal', {
    attrs: {
      "isVisible": _vm.showPasswordModal,
      "hasError": _vm.passwordError,
      "errorMessage": _vm.passwordErrorMessage
    },
    on: {
      "submit": _vm.handlePasswordSubmit,
      "close": _vm.closePasswordModal
    }
  }), _c('MessageAlertModal', {
    attrs: {
      "isVisible": _vm.showMessageAlertModal,
      "title": _vm.messageAlertTitle,
      "message": _vm.messageAlertContent,
      "confirmButtonText": _vm.messageAlertConfirmText
    },
    on: {
      "close": _vm.closeMessageAlert
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex items-center justify-between mb-6"
  }, [_c('h4', {
    staticClass: "text-xl font-bold text-gray-900"
  }, [_vm._v("Admin Details")])]);
}]

export { render, staticRenderFns }